<template>
    <main>
       <div class="container-fluid">
            <div class="row">
               <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                      <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">TeamMembers</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/teammembers/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/TeamMembers/MenuList.vue";
    import lang from "@/views/modules/TeamMembers/language/en";
    import GenericList from "@/components/layout/shared/generic/ListView.vue";

    export default {
        name: "new-categorys",
        components: {
            breadcrumbs,
            GenericList,
        },
        data() {
            return {
                generic: true,
                metaList: [
                    {
                        label: lang.LBL_PI_NAME,
                        link: true,
                        moduleName: 'TeamMembers',
                        routePath: 'teammembers',
                        linkOtherModule:false
                    
                    },
                    {
                        label: lang.LBL_PI_MOBILE,
                        link: true,
                        linkOtherModule:false
                    },
                    {
                        label: lang.LBL_PI_PROFESSIONAL,
                        link: false,
                        linkOtherModule:false
                    },
                    {
                        label: lang.LBL_DESCRIPTION,
                        link: false,
                        linkOtherModule:false
                    },
                ],
                columns: ['assigned_user', 'mobile', 'professional','description'],
            }
        },
        mounted() {
            this.childMethod();
            this.$emit('MetaView', 'Awesome')
        },
        methods: {
            childMethod() {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.columns);
                }
            }
        }
    }
</script>